export default class ImagesModel {
  public main: string = null;
  public cover: string = null;
  public mobile: string = null;
}
